import * as $ from 'jquery';
import 'bootstrap';

export class newDeals {
	private indxBody:any   = $('#mholidays-index-body');

    init():any{
        let _self = this;
        let dealComponents = document.getElementsByClassName('holiday-deals')
        for(let i=0; i < dealComponents.length; i++){
           
            let x =$(dealComponents[i])
            //Data Attributes
            let uiData = x.data()
            let filepath = uiData.dealFilepath;
            let itemsOnLoad = uiData.itemShowonload
            let itemsShowMore = uiData.itemShoweachclick
            let ui_params = {elm:x, itemsOnLoad:itemsOnLoad, itemsShowMore:itemsShowMore}

            _self.getDealsData(filepath,ui_params)

        
        }
        
    }
	
    getDealsData(filePath:any, ui_params:Object): any {
		let _self = this;
		var newDealsUrl;
			if (window.location.hostname === 'localhost' && window.location.port == '5000') {
				newDealsUrl = '/dummy-data/mhholidayDeals.json';
			}
			else {
				newDealsUrl = '/bin/services/new/getMHolidayDeals';
			}

            $.ajax({
                type: 'GET',
                url: newDealsUrl,
                data: $.param({filePath:filePath}),
                async: false,
                success: function (data: any) {
                    if (typeof data === 'string') {
                        data=JSON.parse(data);
                    }
                    _self.dealsDataDisplay(data,ui_params);					
                },
                error: function (error: any) {
                    console.log("Error");
                }
            });	

	}
	dealsDataDisplay(response:any, ui_params: any): void {
		let _self = this;
		$('.see-more-btn').hide()
        
        let $dealsHtml: any='';
		let currentComponent  = ui_params.elm
        var dealsList = response;
        
		if(dealsList.length == 0){
			$dealsHtml +=  '';
		 }else{
			 for (var k in dealsList) {
				$dealsHtml += _self.dealHTML(dealsList[k])
                
			   }
               
		 }

        //First load of deals
        let wrapper = $(currentComponent).find('.wrappercolumn')
		wrapper.html($dealsHtml);
		wrapper.find('.deal-card').slice(0,ui_params.itemsOnLoad).show();
        $('.columncontrol').show();
        
        
        //See more handling

        if(ui_params.itemsOnLoad<dealsList.length){
            $(currentComponent).find('.see-more-btn').show()
        }
        $(currentComponent).find('.see-more-btn').click(function(evt:any) {
            wrapper.find('.deal-card:hidden').slice(0,ui_params.itemsShowMore).slideDown();
            if (wrapper.find('.deal-card:hidden').length == 0) {
                $(this).fadeOut('slow');
            }
        
        });
	}

    dealHTML(deal:any):any{
        let filledStar = new String('<div class="fa fa-star fill"></div>')
        let unfilledStar = new String('<div class="fa fa-star-o"></div>')

        let dealTemplate = `<div class="col-sm-3 deal-card">
        <div class="col-3-3-3-3-1">
        <div class="section"> 
        <span class="top-deals-text">${deal.label}</span>
        <a href = ${deal.dealsURL}>
        <img class="deals-img" src=${deal.imgPath} alt="Top-deals">
        </a>
        <span class="offer-circle">${deal.discount}</span>
        <div class="box-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="12.857" height="17.143" viewBox="0 0 12.857 17.143">
        <defs>
        <style>.a{fill:#61666f;}</style></defs>
        <path class="a" d="M5.768,16.8C.9,9.744,0,9.021,0,6.429a6.429,6.429,0,0,1,12.857,0c0,2.592-.9,3.316-5.768,10.368a.8.8,0,0,1-1.321,0Zm.661-7.69A2.679,2.679,0,1,0,3.75,6.429,2.679,2.679,0,0,0,6.429,9.107Z"/>
        </svg>
        &nbsp;
        <span>${deal.location}</span> 
        <h5>${deal.title}</h5>
        ${filledStar.repeat(deal.rating)}        
        ${unfilledStar.repeat(5-deal.rating)}    
        <div class="deal-description">    
        <p class="deal-package">${deal.packageDetails}</p>
        <p>${deal.description}</p>
        <p class="deal-price">
        <strike>${deal.currency}${deal.actualPrice} &nbsp;</strike>
        <span>${deal.currency}${deal.offerPrice}</span>
        </p>
        </div>
        </div>
        </div>
        </div>
        </div>`

        return dealTemplate;
    }
    
}


    


let scope:Element = document.querySelector('#mholidays-index-body');

if (scope) {
    try{$(document).ready(function() {
        let newdeals = new newDeals()
        newdeals.init();
    });
} catch(e) {console.error(e);}
}